import { useQuery } from '@tanstack/react-query'
import { billsApi } from '@/api/bills-api'
import type { MonitorCostRollup } from '@/types/monitor-cost'

export const useMonitorCostEstimate = (session: string | undefined) => {
  return useQuery<MonitorCostRollup>({
    queryKey: ['cost-estimate', session],
    queryFn: () => billsApi.getSessionMonitorCostEstimate(session as string),
    enabled: !!session
  })
}